import React, { useEffect, useState } from 'react';
import { auth, db } from '../firebase';
import { doc, getDoc } from 'firebase/firestore';

export default function Footer() {
  const [schoolName, setSchoolName] = useState("GIS World");


  return (
    <div>
      <footer
        className="main-footer"
        style={{
          background: "linear-gradient(90deg,#0f172a,#1e293b)",
          color: "#e2e8f0",
          padding: "12px 20px",
          fontSize: 14,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          borderTop: "1px solid rgba(255,255,255,0.08)",
          marginTop: 20,
          boxShadow: "0 -2px 10px rgba(0,0,0,0.1)"
        }}
      >

        {/* RIGHT */}
        <div style={{ display: "flex", alignItems: "center", gap: 15 }}>
          <span style={{ color: "#64748b" }}>
            All rights reserved. Developed by <a href='https://blueviperstechnology.com' target='_blank' style={{ color: "white" }}>Bluevipers Technology <i className='fa fa-heart'></i></a>.
          </span>
        </div>
      </footer>
    </div>
  );
}